import { Button as ThemeButton, ThemeUIStyleObject } from "theme-ui";
import React, { ReactNode } from "react";

type Props = {
  children: ReactNode;
  sx?: ThemeUIStyleObject | undefined;
  onClick?: () => void;
  disabled?: boolean;
};

export const Button: React.FC<Props> = ({
  children,
  sx,
  onClick,
  disabled,
}) => {
  return (
    <ThemeButton sx={{ ...sx }} onClick={onClick} disabled={disabled}>
      {children}
    </ThemeButton>
  );
};
